module.exports = __webpack_public_path__ + "static/media/dealtOnlyQueensJacks_1.654e8b5b.png";